import React from 'react';
import './index.less';

const style = {
    width: '500px',
    height: '400px'
}
class HomePage extends React.Component {

    render() {
        return (
            <div className='container'>
                <h1>Home Page</h1>
            </div>
        );
    }
}

export default HomePage;
